import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { SplashComponent } from './splash/splash.component';
import { ProductDetailsComponent } from './menu/product-details/product-details.component';
import { MostOrderedComponent } from './menu/most-ordered/most-ordered.component';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { AdminappComponent } from './adminapp/adminapp.component';
import { CategoryDetailComponent } from './menu/category-detail/category-detail.component';
import { AttractionsListComponent } from './attractions/attractions-list/attractions-list.component';
import { EventsListComponent } from './events/events-list/events-list.component';
import { EventDetailsComponent } from './events/event-details/event-details.component';
import { PromotionDetailsComponent } from './promotions/promotion-details/promotion-details.component';

const routes: Routes = [
  { 
    path: '', 
    component: SplashComponent,
    data: { animation: 'SplashPage' }
  },
  { 
    path: 'menu', 
    component: MenuComponent,
    data: { animation: 'MenuPage' }
  },
  { 
    path: 'product-details/:id', 
    component: ProductDetailsComponent,
    data: { animation: 'ProductPage' }
  },
  { 
    path: 'most-ordered', 
    component: MostOrderedComponent,
    data: { animation: 'MostOrderedPage' }
  },
  { 
    path: 'order-details', 
    component: OrderDetailsComponent,
    data: { animation: 'OrderPage' }
  },
  {
    path: 'adminapp', 
    component: AdminappComponent
  }, 
  {
    path: 'category/:id',
    component: CategoryDetailComponent,
    data: { animation: 'CategoryDetailPage' }
  },
  {
    path: 'events',
    component: EventsListComponent,
    data: { animation: 'EventsPage' }
  },
  {
    // Singular, and matching what the home banner has always navigated to (menu.component.ts) and
    // what push notifications deep-link by path.
    path: 'event/:id',
    component: EventDetailsComponent,
    data: { animation: 'EventDetailsPage' }
  },
  {
    // Where a `type: "media"` promotion notification lands. The id is the scheduled-promotion
    // DOCUMENT key — the Cloud Function's `redirectPath` builds this path from the document it
    // just sent, and the screen fetches the gallery with it (too large for the push payload).
    path: 'promotion/:id',
    component: PromotionDetailsComponent,
    data: { animation: 'PromotionDetailsPage' }
  },
  {
    path: 'attractions',
    component: AttractionsListComponent,
    data: { animation: 'AttractionsPage' }
  }
  // { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
